@let screeningStatus = screeningSummaryData()?.screeningStatus;
@let screeningValue = screening();

<rt-collapsible-card
  [uniqKey]="`screening-with-ai-${offer().id}`"
  [collapsed]="initialCollapsed()"
  [hasHeaderDivider]="!forceCollapsed()"
  [hasLeftSlotDesc]="true"
  [collapseDisabled]="forceCollapsed()"
  [forceCollapsed]="forceCollapsed()"
  (collapseChanged)="isCardCollapsed.set($event)"
>
  <ng-container leftSlot>
    <rt-badge [color]="'ai'" [text]="'AI'" margin-right-small-x />

    <rt-heading>
      {{ 'app.hire_assistant.assistants_summary' | translate }}
    </rt-heading>
  </ng-container>
  <ng-container bellowLeftSlot>
    <div class="description">
      @if (showOfferTitle() && offer(); as offerVal) {
        <rt-offer-status-indicator [offerStatus]="offerVal" margin-right-small-xx />
        <rt-truncate
          #truncateCmp
          [rtTooltip]="offerVal.title"
          [rtTooltipEnabled]="truncateCmp.isTruncated()"
          class="offer-title"
        >
          {{ offerVal.title }}
        </rt-truncate>
        <rt-divider variant="dot" />
      }
      <span
        class="text-ellipsis"
        [rtTooltip]="descriptionText()"
        [rtTooltipEnableWhenTruncated]="true"
      >
        {{ descriptionText() }}
      </span>
    </div>
  </ng-container>
  <ng-container rightSlot>
    @if (screeningValue) {
      @if (screeningStatus === 'failed') {
        @if (hasScreenActions()) {
          <div layout layout-align-items-center [rtTooltip]="disabledTooltip()">
            <rt-button
              (click)="rescreen.emit(screeningValue.id)"
              size="small"
              [disabled]="actionsDisabled()"
            >
              <rt-icon prefix name="account-search" />
              {{ 'app.ai_candidate_screening.results.try_again' | translate }}
            </rt-button>
          </div>
        }
      } @else {
        <rt-screening-result-indicator
          [screeningResults]="screeningValue.results"
          [screeningStatus]="screeningValue.status"
        />
      }
    } @else {
      @if (hasScreenActions()) {
        <div layout layout-align-items-center [rtTooltip]="disabledTooltip()">
          <rt-button (click)="screen.emit(offer().id)" size="small" [disabled]="actionsDisabled()">
            <rt-icon prefix name="account-search" />
            {{ 'app.ai_candidate_screening.results.screen' | translate }}
          </rt-button>
        </div>
      }
    }
  </ng-container>
  <ng-container collapsible>
    @if (screeningValue && screeningStatus === 'completed') {
      <div padding-tb-small padding-lr-medium>
        <rt-ai-screening-results-list
          [screening]="screeningValue"
          [editable]="editable()"
          [usageLimitReached]="usageLimitReached()"
          [hasScreenActions]="hasScreenActions()"
          [previewMode]="previewMode()"
          [expandable]="true"
          (edit)="edit.emit($event)"
          (screenAgain)="rescreen.emit(screeningValue.id)"
        />
      </div>
    }
  </ng-container>
  <ng-container footer>
    @if (showAiDisclaimer()) {
      <div class="ai-disclaimer">
        <span text-bold>
          {{ 'app.ai_candidate_screening.results.ai_disclaimer_note' | translate }}
        </span>
        {{ 'app.ai_candidate_screening.results.ai_disclaimer' | translate }}
      </div>
    }
  </ng-container>
</rt-collapsible-card>
